"use strict";
// getBettingStructure.ts
//
// A helper function to get the betting structure type based on the defined prefs of the game
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBettingStructure = getBettingStructure;
const BetLimit_1 = require("../BetLimit");
const CapLimit_1 = require("./CapLimit");
const FixedLimit_1 = require("./FixedLimit");
const NoLimit_1 = require("./NoLimit");
const PotLimit_1 = require("./PotLimit");
const SpreadLimit_1 = require("./SpreadLimit");
// TODO: @typify-prefs
// prefs should have it's own type
function getBettingStructure(prefs) {
    switch (prefs.limitType) {
        case BetLimit_1.BetLimit.CAP_LIMIT:
            return new CapLimit_1.CapLimit(prefs);
        case BetLimit_1.BetLimit.FIXED_LIMIT:
            return new FixedLimit_1.FixedLimit(prefs);
        case BetLimit_1.BetLimit.NO_LIMIT:
            return new NoLimit_1.NoLimit(prefs);
        case BetLimit_1.BetLimit.POT_LIMIT:
            return new PotLimit_1.PotLimit(prefs);
        case BetLimit_1.BetLimit.SPREAD_LIMIT:
            return new SpreadLimit_1.SpreadLimit(prefs);
        default:
            throw new Error("Unrecognized or unsupported bet limit type.");
    }
}
//# sourceMappingURL=getBettingStructure.js.map